import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Counter } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CounterModule extends VuexModule {
    @Action
    [Counter.getCounterList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/counters/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Counter.findPageCounter](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counters`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Counter.saveCounter](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counters/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Counter.deleteCounter](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/counters/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}